
import ListRemuneracion from "./List"

const RemuneracionPage = () => {
  return (
    <>
      <ListRemuneracion />
    </>
  )
}

export default RemuneracionPage
